export const profile = {
  name: "Dr. David Homer",
  credentials: "MBA, MSM, MSCS, MSIT",
  title: "Senior Budget Analyst | FP&A Lead",
  phone: "(843) 291-2556",
  phoneHref: "tel:+18432912556",
  email: "davidjohnhomer@gmail.com",
  location: "Summerville, SC",
  linkedin: "linkedin.com/in/david-homer",
  linkedinHref: "https://www.linkedin.com/in/david-homer",
  tagline:
    "FP&A · Budgeting · Forecasting · Variance Analysis · Financial Reporting · Data Analytics · Financial Modeling",
  heroHeadline: "Turning complex budgets into clear, confident decisions.",
  heroSub:
    "Strategic finance leader managing $85M+ public-sector budgets and enterprise-level financial planning & analysis — delivering multimillion-dollar savings and the insight executives rely on.",
};

export const summary =
  "Strategic finance leader with expertise managing $85M+ public-sector budgets and driving enterprise-level financial planning & analysis (FP&A). Proven track record of delivering multimillion-dollar cost savings, improving forecasting accuracy, and advising executive leadership through data-driven insights. Recognized for strengthening financial controls, optimizing performance, and leading cross-functional initiatives in complex, high-accountability environments.";

export const stats = [
  { value: "$85M+", label: "Annual budget managed" },
  { value: "$1M–$3M", label: "Estimated annual savings" },
  { value: "30–40%", label: "Faster financial reporting" },
  { value: "8–12%", label: "Reduced budget variance YoY" },
];

export const competencies = [
  "Budget Management ($85M+)",
  "FP&A",
  "Forecasting",
  "Variance Analysis",
  "KPI Development",
  "Financial Reporting",
  "Data Analytics",
  "ERP Systems",
  "Advanced Excel",
  "Risk & Compliance",
  "Process Improvement",
  "Grant Management ($5M+)",
];

export const technicalSkills = [
  "Excel (Advanced)",
  "Python",
  "SQL",
  "ERP Systems",
  "Financial Modeling",
  "Dashboard & Reporting",
  "Microsoft Office",
  "Google Workspace",
];

export const experience = [
  {
    role: "Budget Analyst",
    company: "Charleston Police Department",
    period: "2017 – Present",
    bullets: [
      "Directed management of an $85M+ annual budget, ensuring alignment with strategic priorities, regulatory compliance, and fiscal accountability across multiple departments.",
      "Partnered with executive leadership including the Chief of Police, 3 Deputy Chiefs, and command staff across 11 departments, influencing high-level financial decisions, resource allocation, and long-term strategic planning.",
      "Identified and implemented cost optimization strategies, contributing to estimated annual savings of $1M–$3M through improved spend controls and process efficiencies.",
      "Led financial forecasting and variance analysis, improving budget accuracy and enabling proactive decision-making across leadership teams.",
      "Developed executive dashboards and financial reporting tools, reducing reporting time by 30–40% and enhancing visibility into key financial metrics.",
      "Strengthened internal controls and audit readiness processes, supporting successful internal/external audits with zero major findings.",
      "Partnered with cross-functional leadership to improve budgeting processes, increasing financial transparency and reducing budget variances by 8–12% year-over-year.",
      "Supported long-range financial planning and mid-year adjustments, aligning financial resources with operational and strategic objectives.",
      "Serves as a key financial advisor to senior leadership, translating complex financial data into actionable insights that drive strategic decisions.",
    ],
  },
];

export const education = [
  {
    degree: "Doctor of Management, Executive Leadership",
    school: "Colorado Technical University",
  },
  {
    degree: "Master of Business Administration (MBA)",
    school: "Colorado Technical University",
  },
  {
    degree: "Master of Science in Management (Project Management)",
    school: "Colorado Technical University",
  },
  {
    degree: "Master of Science in Computer Science (Software Engineering)",
    school: "Colorado Technical University",
  },
  {
    degree: "Master of Science in Information Technology",
    school: "Colorado Technical University",
  },
  {
    degree: "Bachelor of Business Administration",
    school: "Post University",
  },
];

export const certifications = ["Google Data Analytics Professional Certificate"];

export const publications = [
  {
    citation:
      "Homer, D. (2022). A Phenomenological Study on How Stress of Police Work Affects the Officer, Community, and Families in the United States.",
    publisher: "ProQuest Publishing",
  },
];
